export default __webpack_public_path__ + "static/media/_argon-react.436064b7.png";